<template>

  <div>
    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :blank-user-data="blankUserData"
      :grupos-options="gruposOptions"
      :plan-options="gruposOptions"
      @refetch-data="refetchData"
      @update:grupoFilter="grupoFilter = $event"
      @input="showAddEditUsuario"
    />

    <!-- Filters -->
    <users-list-filters
      :role-filter.sync="roleFilter"
      :grupo-filter.sync="grupoFilter"
      :status-filter.sync="statusFilter"
      :role-options="roleOptions"
      :grupo-options="gruposOptions"
      :status-options="statusOptions"
      @statusFilter="updatedStatusFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Client -->
        <template #cell(client)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.cliente.nome)"
                :variant="`light-primary`"
              />
            </template>
            <span class="font-weight-bold d-block text-nowrap">
              <router-link
                :to="{ name: 'app-admin-view-cliente', params: { id: data.item.cliente.id }}"
                class="text-body"
              >{{ data.item.cliente.nome }}</router-link>
            </span>
          </b-media>
        </template>

        <!-- Column: User -->
        <template #cell(nome_usuario)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.nome_usuario)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
              />
            </template>
            <b-link
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.nome_usuario }}
            </b-link>
            <small class="text-muted">@{{ data.item.email_usuario }}</small>
          </b-media>
        </template>

        <!-- Column: Data Criaçaõ -->
        <template #cell(data_inclusao)="data">
          <div class="text-nowrap">
            <span>{{ data.item.data_inclusao | formatDateTimeBr }}</span>
          </div>
        </template>

        <!-- Column: Data Criaçaõ -->
        <template #cell(data_alteracao)="data">
          <div class="text-nowrap">
            <span>{{ data.item.data_alteracao | formatDateTimeBr }}</span>
          </div>
        </template>

        <!-- Column: Role -->
        <template #cell(id_grupousuario)="data">
          <div class="text-nowrap">
            <feather-icon
              v-if="data.item.grupo"
              :icon="resolveUserRoleIcon(data.item.grupo ? data.item.grupo.grupousuario : '')"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.item.grupo ? data.item.grupo.grupousuario : '')}`"
            />
            <span class="align-text-top text-capitalize">{{
              data.item.grupo ? data.item.grupo.grupousuario : ''
            }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="d-flex justify-content-end align-items-center" style="gap: 5px;">
            <b-button
              size="sm"
              variant="success"
              @click="acceptUser(data.item)"
            >
              Aceitar
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              @click="rejectUser(data.item)"
            >
              Recusar
            </b-button>
          </div>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    <ModalConfirm
      id-modal="modal-confirme-delete-user"
      title-modal="Excluir Usuário"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir o usuário?"
      @ok="deletedUser"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, VBModal, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import axios from '@axios'
import {
  ref, onUnmounted, onMounted,
} from '@vue/composition-api'
import { avatarText, formatDateTimeBr } from '@core/utils/filter'
import { deletedUsuarioById } from '@/services/usuarioService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import UsersListFilters from './UsersListFilters.vue'
import useAbilityListSolicitacoes from './useUsersListSolicitacoes'
import userStoreModule from '../userStoreModule'
import UserListAddNew from './UserListAddNew.vue'

export default {
  components: {
    UsersListFilters,
    UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    ModalConfirm,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  filters: {
    formatDateTimeBr,
  },
  setup() {
    const toast = useToast()
    const USER_APP_STORE_MODULE_NAME = 'app-adm-usuarios'
    const idUsuario = ref(null)
    const blankUserData = ref({
      id: null,
      nome_cliente: '',
      id_cliente: null,
      login: '',
      senha: null,
      ativo: 1,
      id_grupousuario: null,
    })

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
    } = useAbilityListSolicitacoes()

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)
    const gruposOptions = ref([])

    const updatedStatusFilter = e => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchUsers`)
    }
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)
    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addUsuario = async () => {
      blankUserData.value = {
        id: null,
        nome_cliente: '',
        id_cliente: null,
        login: '',
        senha: null,
        ativo: 1,
        id_grupousuario: null,
      }
      isAddNewUserSidebarActive.value = true
    }

    const deletedUser = async () => {
      if (idUsuario.value === null) return
      await deletedUsuarioById(idUsuario.value)
        .then(() => {
          idUsuario.value = null
          refetchData()
        })
      refetchData()
    }

    const editarUsuario = async id_usuario => {
      await store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchUser`, { id: id_usuario })
        .then(data => {
          blankUserData.value = data.data
          blankUserData.value.id_grupousuario = data.data.grupo
          blankUserData.value.nome_cliente = data.data.cliente.nome
          isAddNewUserSidebarActive.value = true
        })
    }

    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ]

    const statusOptions = [
      { label: 'Todos', value: '' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    onMounted(() => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchGrups`)
        .then(data => {
          data.grupos.map(grupo => {
            gruposOptions.value.push(grupo)
          })
        })
    })

    const acceptUser = async item => {
      try {
        // Atualizar status do usuário para aprovado
        await axios.put(`/users/${item.id}`, {
          aprovado: 'Aprovado',
        })
        // Criar registros específicos baseados no grupo do usuário
        if (item.id_grupousuario === 4) {
          await axios.post('/afiliado', {
            id_usuario: item.id,
            codigo: item.codigo,
            ativo: 1,
          })
        } else if (item.id_grupousuario === 5) {
          await axios.post('/vendedor', {
            id_usuario: item.id,
            codigo: item.codigo,
            compania: '',
            erp: false,
            ativo: 1,
            pagamento: '',
          })
        } else if (item.id_grupousuario === 6) {
          await axios.post('/padrinho', {
            id_usuario: item.id,
            ativo: 1,
          })
        }

        // Recarregar dados da tabela
        await refetchData()

        toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Usuário aprovado com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        console.error('Erro ao aprovar usuário:', error)
        toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro ao aprovar usuário',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    }

    const rejectUser = async item => {
      try {
        await axios.put(`/users/${item.id}`, {
          aprovado: 'Rejeitado',
        })
        
        // Recarregar dados da tabela
        await refetchData()

        toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Usuário rejeitado com sucesso!',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      } catch (error) {
        console.error('Erro ao rejeitar usuário:', error)
        toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Erro ao rejeitar usuário',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    }

    return {
      idUsuario,
      addUsuario,
      blankUserData,
      editarUsuario,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      roleOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      updatedStatusFilter,
      deletedUser,
      acceptUser,
      rejectUser,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
